import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import styles from './TruckHero.module.postcss';
import ConfigContext from '../../../contexts/ConfigContext';
import locationDefaultPhoto from '../../../utils/locationDefaultPhoto';
import ErrorBoundary from '../../shared/ErrorBoundary';

const sliderSettings = {
  infinite: false,
  slidesToShow: 2.25,
  slidesToScroll: 2,
  lazyLoad: 'anticipated',
  waitForAnimate: false,
  useCSS: true,
  useTransform: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
};

function TruckHero({ photos, alt }) {
  const { city_name } = useContext(ConfigContext);

  let slidePhotos = photos;
  if (photos && photos.length === 0) {
    slidePhotos = [locationDefaultPhoto(city_name)];
  }

  const totalSlides = (slidePhotos || ['']).length;
  const slides = (slidePhotos || ['']).map((photo, index) => {
    return (
      <div
        key={photo}
        className={styles.TruckHero_slide}
        role='group'
        aria-roledescription='slide'
        aria-label={`Photo ${index + 1} of ${totalSlides}`}
      >
        <img
          className={styles.TruckHero_img}
          src={photo}
          alt={index === 0 ? (alt || '') : ''}
          fetchpriority={index === 0 ? 'high' : 'auto'}
          loading={index === 0 ? 'eager' : 'lazy'}
        />
      </div>
    );
  });

  return (
    <section className='Section u-pt0 u-pb3' aria-label='Photo gallery'>
      <div className={styles.TruckHero} aria-roledescription='carousel'>
        <Slider className={styles.TruckHero_slider} {...sliderSettings}>
          {slides}
        </Slider>
      </div>
    </section>
  );
}

TruckHero.propTypes = {
  photos: PropTypes.array,
};

// react-slick / third-party render paths can throw; a crash drops the hero and keeps the truck page.
// Wrapped here rather than at every call site.
function TruckHeroBoundary(props) {
  return (
    <ErrorBoundary name='TruckHero'>
      <TruckHero {...props} />
    </ErrorBoundary>
  );
}

export default TruckHeroBoundary;
